interface ReconnectableSocket {
  disconnect(): unknown;
  connect(): unknown;
}

export function refreshSocketAuthentication(socket: ReconnectableSocket | null): void {
  if (!socket) return;
  socket.disconnect();
  socket.connect();
}
